import { render, staticRenderFns } from "./ForumTemuan.vue?vue&type=template&id=0b460017&scoped=true&"
import script from "./ForumTemuan.vue?vue&type=script&lang=js&"
export * from "./ForumTemuan.vue?vue&type=script&lang=js&"
import style0 from "./ForumTemuan.vue?vue&type=style&index=0&id=0b460017&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b460017",
  null
  
)

export default component.exports